import { Dialog as DialogPrimitive } from "radix-ui";

export const DialogTrigger = DialogPrimitive.Trigger;
